export default __webpack_public_path__ + "static/media/hht2_storybook_18.93913283.png";